import { useState } from 'react';

import { HISTORY_KEY, MAX_HISTORY } from '@/features/search-bar/constants';
import type { HistoryItem } from '@/features/search-bar/types';

export function useSearchHistory() {
    const [searchHistory, setSearchHistory] = useState<HistoryItem[]>(() => {
        try {
            return JSON.parse(
                localStorage.getItem(HISTORY_KEY) ?? '[]',
            ) as HistoryItem[];
        } catch {
            return [];
        }
    });
    const [showAllHistory, setShowAllHistory] = useState(false);

    const saveToHistory = (item: Omit<HistoryItem, 'id'>) => {
        setSearchHistory((prev) => {
            const filtered = prev.filter(
                (h) => h.query.toLowerCase() !== item.query.toLowerCase(),
            );
            const next = [
                { ...item, id: Date.now().toString() },
                ...filtered,
            ].slice(0, MAX_HISTORY);
            localStorage.setItem(HISTORY_KEY, JSON.stringify(next));
            return next;
        });
    };

    const removeFromHistory = (id: string, e: React.MouseEvent) => {
        e.stopPropagation();
        setSearchHistory((prev) => {
            const next = prev.filter((h) => h.id !== id);
            localStorage.setItem(HISTORY_KEY, JSON.stringify(next));
            return next;
        });
    };

    return {
        searchHistory,
        showAllHistory,
        setShowAllHistory,
        saveToHistory,
        removeFromHistory,
    };
}
